module.exports = {
      id: "arrow-usage",
      viewBox: "0 0 8.063 11.15",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#arrow",
      toString: function () {
        return this.url;
      }
    }